import pluralize from "pluralize";
import {Link} from "react-router";

import {ServiceUsage} from "@/lib/types/checks.ts";

interface InstantCheckoutPurchaseSuccessProps {
  serviceUsage: ServiceUsage;
}

export const InstantCheckoutPurchaseSuccess = ({serviceUsage}: InstantCheckoutPurchaseSuccessProps) => (
  <small>
    <p>
      The payment was successful. Invoice details will appear on the{" "}
      <Link to="/billing/history" target="_blank">
        Invoices page
      </Link>{" "}
      within next 2 hours.
    </p>
    <p>
      {serviceUsage.bundle_size}{" "}
      <strong>
        {serviceUsage.limit_name} {pluralize("check", serviceUsage.bundle_size)}
      </strong>{" "}
      {pluralize("was", serviceUsage.bundle_size)} added to your account.
    </p>
  </small>
);
